const getHost = () => {
    // Returns '' when window is unavailable (SSR)
    // Uses window.location.host only in the browser
    if (typeof window === 'undefined' || !window.location) {
        return '';
    }
    return window.location.host;
};
const host = getHost();
export const isLocal = host.includes('localhost');
export const isLowerEnvironment = isLocal || host.includes('dev') || host.includes('qa') || host.includes('preprod');
export const _console = {
    log: (msg, ...args) => {
        if (isLowerEnvironment) {
            console.log(msg, ...args);
        }
    },
    error: (msg, ...args) => {
        if (isLowerEnvironment) {
            console.error(msg, ...args);
        }
    },
    warn: (msg, ...args) => {
        if (isLowerEnvironment) {
            console.warn(msg, ...args);
        }
    },
};
